export interface AnnualEIT104000List {
    row?: string,
    name?: string,
    amount?: string,
    indent?: number,
    rowspan?: number,
    isEdit?: boolean,
    isEdit2?: boolean,
    isEdit3?: boolean,
    isEdit4?: boolean,
    isEdit5?: boolean,
    isEdit6?: boolean,
    type?: string,
    salesFee?: string,
    managementFee?: string,
    financeFee?: string,
    salesOverseasFee?: string,
    managementOverseasFee?: string,
    financeOverseasFee?: string,
    accountBookId?: number | null,
    id?: null | number | string
}

let list: AnnualEIT104000List[] = [
    {
        name: "一、职工薪酬",
        row: "1",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "二、劳务费",
        row: "2",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "三、咨询顾问费",
        row: "3",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "四、业务招待费",
        row: "4",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "五、广告费和业务宣传费",
        row: "5",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "六、佣金和手续费",
        row: "6",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: true,
        isEdit6: true,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "七、资产折旧摊销费",
        row: "7",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "八、财产损耗、盘亏及毁损损失",
        row: "8",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "九、办公费",
        row: "9",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十、董事会费",
        row: "10",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十一、租赁费",
        row: "11",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十二、诉讼费",
        row: "12",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十三、差旅费",
        row: "13",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十四、保险费",
        row: "14",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十五、运输、仓储费",
        row: "15",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十六、修理费",
        row: "16",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十七、包装费",
        row: "17",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十八、技术转让费",
        row: "18",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "十九、研究费用",
        row: "19",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "二十、各项税费",
        row: "20",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "二十一、利息收支",
        row: "21",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "二十二、汇兑差额",
        row: "22",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        isEdit5: true,
        isEdit6: true,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "二十三、现金折扣",
        row: "23",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        isEdit5: true,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "二十四、党组织工作经费",
        row: "24",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: true,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "二十五、其他",
        row: "25",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: true,
        isEdit2: true,
        isEdit3: true,
        isEdit4: true,
        isEdit5: true,
        isEdit6: true,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },
    {
        name: "合计(1+2+3+…25)",
        row: "26",
        amount: "",
        indent: 0,
        salesFee: "",
        managementFee: "",
        financeFee: "",
        isEdit: false,
        isEdit2: false,
        isEdit3: false,
        isEdit4: false,
        isEdit5: false,
        isEdit6: false,
        salesOverseasFee: "",
        managementOverseasFee: "",
        financeOverseasFee: "",
        accountBookId: null,
        id: null,
    },


]


let AnnualEIT104000 = list
export default AnnualEIT104000
